var _rect, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDolar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 49,
    viewBox: "0 0 70 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 69,
    height: 47,
    rx: 5.5,
    fill: "white",
    stroke: "#D9D9D9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 24.5,
    r: 17,
    fill: "#0A49A5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.292 30.926C34.452 30.926 33.672 30.77 32.952 30.458C32.232 30.134 31.62 29.696 31.116 29.144C30.612 28.592 30.24 27.956 30 27.236L31.8 26.48C32.124 27.308 32.598 27.944 33.222 28.388C33.846 28.832 34.566 29.054 35.382 29.054C35.862 29.054 36.282 28.982 36.642 28.838C37.002 28.682 37.278 28.466 37.47 28.19C37.674 27.914 37.776 27.596 37.776 27.236C37.776 26.744 37.638 26.354 37.362 26.066C37.086 25.778 36.678 25.55 36.138 25.382L33.618 24.59C32.61 24.278 31.842 23.804 31.314 23.168C30.786 22.52 30.522 21.764 30.522 20.9C30.522 20.144 30.708 19.484 31.08 18.92C31.452 18.344 31.962 17.894 32.61 17.57C33.27 17.246 34.02 17.084 34.86 17.084C35.664 17.084 36.396 17.228 37.056 17.516C37.716 17.792 38.28 18.176 38.748 18.668C39.228 19.16 39.576 19.73 39.792 20.378L38.028 21.152C37.764 20.444 37.35 19.898 36.786 19.514C36.234 19.13 35.592 18.938 34.86 18.938C34.416 18.938 34.026 19.016 33.69 19.172C33.354 19.316 33.09 19.532 32.898 19.82C32.718 20.096 32.628 20.42 32.628 20.792C32.628 21.224 32.766 21.608 33.042 21.944C33.318 22.28 33.738 22.532 34.302 22.7L36.642 23.438C37.71 23.762 38.514 24.23 39.054 24.842C39.594 25.442 39.864 26.192 39.864 27.092C39.864 27.836 39.666 28.496 39.27 29.072C38.886 29.648 38.352 30.104 37.668 30.44C36.984 30.764 36.192 30.926 35.292 30.926ZM34.464 32.51V15.5H35.904V32.51H34.464Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDolar);
export default __webpack_public_path__ + "static/media/dolar.87f597d86b06c0b539dcef27c2189ebf.svg";
export { ForwardRef as ReactComponent };